module.exports = __webpack_public_path__ + "img/tech-13.2b60d7dc.jpg";